module.exports = __webpack_public_path__ + "static/media/фотограф.4a099c0b.jpg";